// extracted by mini-css-extract-plugin
export default {"root":"DisplayBox_root__H-ZtY"};